"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionProps = exports.drawerProps = exports.SHADE_PICKER_DIALOG = void 0;
const SHADE_PICKER_DIALOG = exports.SHADE_PICKER_DIALOG = 'shade-picker-dialog';
const transitionProps = exports.transitionProps = {
  timeout: 0
};
const drawerProps = exports.drawerProps = {
  disableEnforceFocus: true
};
//# sourceMappingURL=constants.js.map